export default __webpack_public_path__ + "static/media/KioskIcon.4793d97d.svg";